import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {AssetSchema} from './asset'

export const AssetLinkSchema = buildEntrySchemaFor('assetLink', {
  fields: z.lazy(() =>
    z.object({
      asset: AssetSchema.optional(),
      text: z.string().optional().default(''),
      openInNewTab: z.boolean().optional(),
    }),
  ),
})

export type AssetLink = z.infer<typeof AssetLinkSchema>

export function isAssetLink(entry: unknown): entry is AssetLink {
  return AssetLinkSchema.safeParse(entry).success
}
